import { Box, Button, HStack, Icon, SearchInput, Text } from '@genial/components';
import { Color, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';
import { fixedFeeTermsFiltersAtom } from '../../../../../../store/fixedFee/atom';
import { fixedFeeSearchPlaceholder } from '../../constants';

import { FixedFeeTermsHeaderProps } from '.';

export const FixedFeeTermsHeaderDesktop: React.FC<FixedFeeTermsHeaderProps> = ({
  onSearch,
  onClearSearch,
  onRefresh,
  disabled,
}) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { appliedFilters } = useRecoilValue(fixedFeeTermsFiltersAtom);

  return (
    <HStack
      p="inline.xxs"
      pb={0}
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      space="stack.xxxs">
      <SearchInput
        onSearch={onSearch}
        onClear={onClearSearch}
        placeholder={fixedFeeSearchPlaceholder}
        hStackProps={{ mb: 0 }}
        isLoading={disabled}
      />

      <HStack alignItems="center" space="inline.xxs" flexWrap="wrap">
        <Button
          p={0}
          variant="textLink"
          onPress={onRefresh}
          isDisabled={disabled}
          rightIcon={<Icon name="Refresh" size="xxxs" color="brand.tertiary.principal" />}>
          Atualizar
        </Button>
        <Button
          p={0}
          variant="textLink"
          isDisabled={disabled}
          onPress={() => navigate('FixedFeeReportModal')}
          rightIcon={<Icon name="FileExe" size="xxxs" color="brand.tertiary.principal" />}>
          Relatórios
        </Button>
        <Button
          variant="secondary"
          onPress={() => navigate('FixedFeeFilterModal')}
          _text={{ textTransform: 'none' }}
          isDisabled={disabled}
          {...(!appliedFilters.length && {
            rightIcon: <Icon name="Funnel" size="xxxs" color={Color['neutral.black']} />,
          })}>
          <HStack alignItems="center" justifyContent="center" space="inline.nano">
            <Text variant="semibold" fontSize="md" color="neutral.black">
              Filtrar
            </Text>
            {!!appliedFilters.length && (
              <Box
                borderRadius="full"
                w="20px"
                h="20px"
                alignItems="center"
                justifyContent="center"
                bg={Color['brand.tertiary.light']}>
                <Text variant="regular" fontSize={Typography['fontsize.xs']} color="neutral.white">
                  {appliedFilters.length}
                </Text>
              </Box>
            )}
          </HStack>
        </Button>
      </HStack>
    </HStack>
  );
};
